/** Sichtbarer Hinweis, wenn ein Ort getippt, aber kein Vorschlag gewählt wurde. */
export const FUNDORT_UNSELECTED_HINT =
  "Kein Vorschlag ausgewählt. Der getippte Ort wird als Freitext gespeichert.";

export function foundPlaceNeedsHint(placeId: string | null, typed: string): boolean {
  return placeId == null && typed.trim().length > 0;
}

/**
 * Katalogort bleibt die Id. Getippter Text ohne Auswahl wird nicht verworfen,
 * sondern als Freitext gespeichert. Die Ergänzung bleibt erhalten.
 */
export function foundPlaceForSave(input: {
  placeId: string | null;
  typed: string;
  extra: string;
}): { foundPlaceId: string | null; foundPlaceText: string | null } {
  const typed = input.typed.trim();
  const extra = input.extra.trim();
  if (input.placeId) {
    return { foundPlaceId: input.placeId, foundPlaceText: extra || null };
  }
  if (!typed) {
    return { foundPlaceId: null, foundPlaceText: extra || null };
  }
  return {
    foundPlaceId: null,
    foundPlaceText: extra ? `${typed} (${extra})` : typed,
  };
}
